const format = function(number = 0, numberFormatConfig = {}) {
  const rounded = number.toFixed(numberFormatConfig.precision);
  const parts = rounded.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, numberFormatConfig.thousands);
  return parts.join(numberFormatConfig.decimals);
};
const apply = function(number = 0, numberFormatConfig = {}) {
  const formatted = format(number, numberFormatConfig);
  if (numberFormatConfig.currencypos === "left") {
    return numberFormatConfig.currency + " " + formatted;
  }
  return formatted + " " + numberFormatConfig.currency;
};
const parse = function(number = "", numberFormatConfig = {}) {
  const flattened = number.replace(numberFormatConfig.thousands, "").replace(numberFormatConfig.decimals, ".").replace(" ", "").replace(numberFormatConfig.currency, "");
  return parseFloat(flattened);
};
exports.format = format;
exports.apply = apply;
exports.parse = parse;
